module.exports = __webpack_public_path__ + "static/z16-2-0003-c60fd4ceb79ac88e6295cfef86a4eaa2.jpg";